<table mdbTable class="z-depth-1" #tableEl="mdbTable">
  <thead *ngIf="!isLoading">
    <tr>
      <th scope="col" [mdbTableSort]="data" sortBy="day_of_week">
        Day Of Week<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="date">
        Date<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="units">
        Units<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="avg_price">
        Avg Price<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="subtotal">
        Sub Total<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="service_fees">
        Service Fees<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="tips">
        Tips<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="tip_percentage">
        Tip %<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="total">
        Total<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="redeemed">
        # Redeemed<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="redeemed_percentage">
        % Redeemed<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="revenue_percentage">
        % Revenue<mdb-icon fas icon="sort"></mdb-icon>
      </th>
    </tr>
  </thead>
  <tbody *ngIf="!isLoading">
    <tr *ngFor="let element of data; let i = index">
      <td scope="row" *ngIf="show(i)">
        {{ element.day_of_week }}
      </td>
      <td scope="row" *ngIf="show(i)">
        {{ element.date | date: "shortDate" }}
      </td>
      <td scope="row" *ngIf="show(i)">
        {{ element.units }}
      </td>
      <td scope="row" *ngIf="show(i)">{{ element.avg_price | currency }}</td>
      <td scope="row" *ngIf="show(i)">{{ element.subtotal | currency }}</td>
      <td scope="row" *ngIf="show(i)">
        {{ element.service_fees | currency }}
      </td>
      <td scope="row" *ngIf="show(i)">{{ element.tips | currency }}</td>
      <td scope="row" *ngIf="show(i)">
        {{ element.tip_percentage | percent }}
      </td>
      <td scope="row" *ngIf="show(i)">{{ element.total | currency }}</td>
      <td scope="row" *ngIf="show(i)">
        {{ element.redeemed }}
      </td>
      <td scope="row" *ngIf="show(i)">
        {{ element.redeemed_percentage | percent }}
      </td>
      <td scope="row" *ngIf="show(i)">
        {{ element.revenue_percentage | percent }}
      </td>
    </tr>
  </tbody>
  <tfoot *ngIf="!isLoading" class="">
    <tr class="totals-row">
      <td scope="row" class="left">TOTAL</td>
      <td></td>
      <td>{{ tUnits }}</td>
      <td>{{ tAvgPrice | currency }}</td>
      <td>{{ tSubtotal | currency }}</td>
      <td>{{ tServiceFees | currency }}</td>
      <td>{{ tTips | currency }}</td>
      <td>{{ tTipPercentage | percent }}</td>
      <td>{{ tTotal | currency }}</td>
      <td>{{ tRedeemed }}</td>
      <td>{{ tRedeemedPercentage | percent }}</td>
      <td scope="row" class="right">{{ tRevenue | percent }}</td>
    </tr>
  </tfoot>
</table>
<div class="d-flex flex-row no-gutters  align-items-center">
  <div class="chip" mdbDropdown>
    <div class="btn-group" mdbDropdownToggle>
      {{ filter.showing }}
      <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
    </div>
    <div class="dropdown-menu dropdown-primary">
      <a
        class="dropdown-item"
        *ngFor="let item of fb.analytics.filter.itemsPerPage"
        (click)="setItemsPerPage(item)"
        >{{ item }}</a
      >
    </div>
  </div>
  <label>per page</label>
  <label class="ml-auto">{{
    filter.firstIndex +
      1 +
      "-" +
      (filter.lastIndex > data.length ? data.length : filter.lastIndex) +
      " of " +
      data.length
  }}</label>

  <button (click)="decrement()">
    <i class="fas fa-chevron-left grey-text"></i>
  </button>
  <button (click)="increment()">
    <i class="fas fa-chevron-right grey-text"></i>
  </button>
  <!-- <div class="btn" (click)="decrement()">
    <mdb-icon fas icon="chevron-left" class="close"></mdb-icon>
  </div>
  <div class="btn " (click)="increment()">
    <mdb-icon fas icon="chevron-right" class="close"></mdb-icon>
  </div> -->
</div>
